// const { createSlice } = require('@reduxjs/toolkit')

import { createSlice } from '@reduxjs/toolkit'

const initialState = { user: {} }
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setSiteUser: (state, action) => {
      state.user = action.payload
    },
    setUserWizardDone: (state, action) => {
      let user = state.user
      let user_wizard = []

      user.user_wizard.forEach((el) => {
        if (el.step === action.payload.step) {
          user_wizard.push({
            ...el,
            completed: action.payload.completed,
            skip: action.payload.skip,
            status: 'done',
          })
        } else {
          user_wizard.push({ ...el })
        }
      })
      user.user_wizard = user_wizard
      state.user = user
    },
    setUserWizardSkip: (state, action) => {
      let user = state.user
      let user_wizard = []

      user.user_wizard.forEach((el) => {
        if (el.step === action.payload.step) {
          user_wizard.push({ ...el, skip: action.payload.skip, status: 'skip' })
        } else {
          // IMPORTANT: Don't modify other steps - only update the one being skipped
          user_wizard.push({ ...el })
        }
      })
      user.user_wizard = user_wizard
      state.user = user
    },
    setUserWizardSkipAll: (state, action) => {
      let user = state.user
      let user_wizard = []

      user.user_wizard.forEach((el) => {
        user_wizard.push({ ...el, skip: true })
      })
      user.user_wizard = user_wizard
      state.user = user
    },
    setSitePersonnaliser: (state, action) => {
      let user = state.user
      user.personnaliser = action.payload
      state.user = user
    },
  },
})

export const {
  setSiteUser,
  setSitePersonnaliser,
  setUserWizardSkip,
  setUserWizardDone,
  setUserWizardSkipAll,
} = userSlice.actions
export default userSlice.reducer
